import React from 'react';

import { orderStatusVariant } from '../utils/order-status-variant';

interface IProps {
  code: string;
  label: string;
  variant?: string;
}

export default function StatusBadge({
  code,
  label,
  variant,
}: IProps): React.JSX.Element {
  const resolvedVariant = variant ?? orderStatusVariant(code);
  return (
    <span
      className={`status-badge${resolvedVariant ? ` status-badge--${resolvedVariant}` : ''}`}
    >
      {label}
    </span>
  );
}
